import { EvaChartStates } from "types/factory";

import { createMpcCompatibleTooltipOptions } from "./mpcTooltip";

export function translateCumTimeResponseTooltipOptions(states: EvaChartStates) {
  return createMpcCompatibleTooltipOptions(states, {
    className: "chart-tooltip-container"
  });
}
